import { app } from '../../../../app';
import { Controller } from './hard-token-sync.controller';

app.component('companyHardTokenManagementSync', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./hard-token-sync.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/hard-token-management/hard-token-sync/hard-token-sync.component.js